import { render, staticRenderFns } from "./UnsettledFundOrderTable.vue?vue&type=template&id=5d4a3987&scoped=true"
import script from "./UnsettledFundOrderTable.vue?vue&type=script&lang=js"
export * from "./UnsettledFundOrderTable.vue?vue&type=script&lang=js"
import style0 from "./UnsettledFundOrderTable.vue?vue&type=style&index=0&id=5d4a3987&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4a3987",
  null
  
)

export default component.exports